// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__28Uo0","loaderOuter":"PageOverlayLoader_loaderOuter__rwfQ2"};